import { Component, Input, OnInit } from '@angular/core';

import {
  trigger,
  state,
  style,
  transition,
  animate,
} from '@angular/animations';
import { CommunicationService } from 'src/app/providers/communication/communication.service';
import { DashboardService } from 'src/app/providers/dashboard/dashboard.service';
import { NotificationService } from 'src/app/service/toaster/notification.service';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { GeneralService } from 'src/app/providers/general/general.service';
import { OwlOptions } from 'ngx-owl-carousel-o';

declare let $: any;

@Component({
  selector: 'app-news-landing-page',
  templateUrl: './news-landing-page.component.html',
  styleUrls: ['./news-landing-page.component.scss'],
  animations: [
    trigger('slideInOut', [
      state(
        'in',
        style({
          width: '0%',
        })
      ),
      state(
        'out',
        style({
          width: '100%',
        })
      ),
      transition('in => out', animate('400ms ease-in-out')),
      transition('out => in', animate('400ms ease-in-out')),
    ]),
  ],
})
export class NewsLandingPageComponent implements OnInit {
  @Input() isAlumini: boolean;
  customOptions: OwlOptions = {
    // loop: true,
    autoplay: true,
    // responsiveClass: true,
    // navText: ['<', '>'],
    responsive: {
      0: {
        items: 1,
      },
      480: {
        items: 1,
      },
      940: {
        items: 1,
      },
    },
    // nav: true,
  };
  glryOptions: OwlOptions = {
    // loop: true,
    autoplay: true,
    // responsiveClass: true,
    navText: ['Prev', 'Next'],
    responsive: {
      0: {
        items: 1,
      },
      480: {
        items: 1,
      },
      940: {
        items: 1,
      },
    },
    nav: true,
  };

  vdoOptions: OwlOptions = {
    // loop: true,
    // autoplay: true,
    // responsiveClass: true,
    // navText: ['<', '>'],
    responsive: {
      0: {
        items: 1,
      },
      480: {
        items: 1,
      },
      940: {
        items: 1,
      },
    },
    // nav: true,
  };

  public editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: '12rem',
    minHeight: '5rem',
    placeholder: 'Enter News description here...',
    translate: 'no',
    defaultParagraphSeparator: 'p',
    defaultFontName: 'Arial',
    toolbarHiddenButtons: [
      ['bold'],
      [
        'insertImage',
        'insertVideo',
        'insertHorizontalRule',
        'removeFormat',
        'toggleEditorMode',
      ],
    ],
    customClasses: [
      {
        name: 'quote',
        class: 'quote',
      },
      {
        name: 'redText',
        class: 'redText',
      },
      {
        name: 'titleText',
        class: 'titleText',
        tag: 'h1',
      },
    ],
  };
  newsData = [];
  trendingArr = [];
  categories = [];
  imagesArr = [];
  galleryData = [];
  newsStat: any;
  empData: any;
  isLastNewsPage = false;
  hasData = false;
  submit = false;
  headerName = 'My Feed';
  commonData = {
    limit: 5,
    cat_id: '',
    source: 'Web',
    lang_id: '',
    is_for_alumini: '1',
  };
  catId;
  txnId;
  siteNewsForm: FormGroup;
  today: any;
  allFiles: any = [];
  languageList: any = [];
  glryIndex = 3;
  crntEvent = '';
  constructor(
    private httpComs: CommunicationService,
    private dashboardService: DashboardService,
    private notifyService: NotificationService,
    private route: ActivatedRoute,
    public translate: TranslateService,
    private httpGen: GeneralService,
    private router: Router
  ) {
    this.today = moment().format('YYYY-MM-DD');

    this.route.paramMap.subscribe((params: ParamMap) => {
      this.catId = params.get('id');
      this.txnId = params.get('txnId');
    });

    this.httpGen.crntLanguage.subscribe((res) => {
      if (res != 0) {
        this.commonData.lang_id = `${res}`;
        this.getGeneralNews(this.commonData);
      }
    });
  }

  ngOnInit(): void {
    this.commonData.is_for_alumini = this.isAlumini == true ? '2' : '1';
    this.getGeneralNews(this.commonData);
    this.getLoggedInEmpDetails();
    this.getCategories();
    this.getNewsStat();
    this.siteFormInit();
    this.languageGet();
    this.getGallery({ cat_id: '' });
    this.httpGen.showLang.next(true);
    const tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';
    document.body.appendChild(tag);
  }

  get newsError(): any {
    return this.siteNewsForm.controls;
  }

  langModal(): void {
    const tmp = localStorage.getItem('so_lang');
    if (tmp) {
      this.translate.use(tmp + '_lang');
      this.commonData.lang_id = tmp;
      this.getGeneralNews(this.commonData);
      if (this.trendingArr.length == 0) {
        this.getTrendingNews(this.commonData);
      }
    } else {
      $('#lang_modal_nws').modal({ backdrop: 'static', keyboard: false });
    }
  }

  languageGet(): void {
    this.httpGen.getLanguage().subscribe((res) => {
      this.languageList = res.data;
      this.langModal();
    });
  }

  getLanguage(event): void {
    if (event.target.value) {
      localStorage.setItem('so_lang', event.target.value);
      this.httpGen.crntLanguage.next(event.target.value);
      $('#lang_modal_nws').modal('hide');
      this.translate.use(event.target.value + '_lang');
      this.commonData.lang_id = event.target.value;
      if (this.trendingArr.length == 0) {
        this.getTrendingNews(this.commonData);
      }
    }
  }

  siteFormInit(): void {
    this.siteNewsForm = new FormGroup({
      org_id: new FormControl('1'),
      news_title: new FormControl('', Validators.required),
      short_desc: new FormControl(''),
      news_desc: new FormControl('', Validators.required),
    });
  }

  getLoggedInEmpDetails(): void {
    this.dashboardService.getLoggedInEmpDetails().subscribe((res) => {
      this.empData = res.data;
    });
  }

  getNewsStat(): void {
    this.httpComs.getNewsUserStat().subscribe((res) => {
      this.newsStat = res.data;
    });
  }

  getCategories(): void {
    this.httpComs.getMappedCategoryList().subscribe((res) => {
      this.categories = res.data;
    });
  }

  getGeneralNews(commonData): void {
    this.httpComs.getGeneralNews(commonData).subscribe((res) => {
      if (res.status) {
        this.newsData = res.data.data;
        if (this.newsData.length == res.data.total) {
          this.isLastNewsPage = true;
        } else {
          this.isLastNewsPage = false;
        }
        this.newsData.forEach((ele) => {
          ele.img_arr = [];
          ele.vdo_arr = [];
          ele.files = [];
          ele.youtube_files = [];
          ele.docs.forEach((element) => {
            if (element.doc_type == 'img') {
              ele.img_arr.push(element.attach_info);
            } else if (element.doc_type == 'video') {
              ele.vdo_arr.push(element.attach_info);
            } else {
              console.log(this.validateYouTubeUrl(element.attach_info));
              if (this.validateYouTubeUrl(element.attach_info) != false) {
                ele.youtube_files.push(
                  this.validateYouTubeUrl(element.attach_info)
                );
              } else {
                ele.files.push(element.attach_info);
              }
            }
          });
          ele.content = ele.news_desc;
          ele.nonEditedContent = ele.content;
          ele.isContentToggled = false;
          ele.content = this.formatContent(ele);
        });
        console.log(this.newsData);
        if (this.txnId) {
          for (let i = 0; i < this.newsData.length; i++) {
            if (this.newsData[i].txn_id == this.txnId) {
              this.newsData[i].display_priority = 0;
            } else {
              this.newsData[i].display_priority = i + 1;
            }
          }
        }
        this.hasData = true;
      } else {
        this.newsData = [];
      }
    });
  }

  validateYouTubeUrl(url): any {
    console.log(url);
    let regExp =
      /(?:\?v=|\/embed\/|\.be\/|\/v\/|\/\d{1,2}\/|\/vevo\/|youtu\.be\/|\/embed\/|\/v\/|e\/|youtu\.be\/|embed\/|watch\?v=|&v=|&vi=|vi=|https:\/\/www\.youtube\.com\/watch\?v=)([^#\&\?]{11})/;
    let matches = url.match(regExp);
    console.log(matches);
    if (matches) {
      console.log(matches);
      return matches[1];
    } else {
      return false;
    }
  }

  getTrendingNews(commonData): void {
    this.httpComs.getTrendingNews(commonData).subscribe((res) => {
      if (res.status) {
        this.trendingArr = res.data;
        this.trendingArr.forEach((ele) => {
          ele.img_arr = [];
          ele.vdo_arr = [];
          ele.files = [];
          ele.youtube_files = [];
          ele.docs.forEach((element) => {
            if (element.doc_type == 'img') {
              ele.img_arr.push(element.attach_info);
            } else if (element.doc_type == 'video') {
              ele.vdo_arr.push(element.attach_info);
            } else {
              if (this.validateYouTubeUrl(element.attach_info)) {
                ele.youtube_files.push(
                  this.validateYouTubeUrl(element.attach_info)
                );
              } else {
                ele.files.push(element.attach_info);
              }
            }
          });
          ele.content = ele.news_desc;
          ele.nonEditedContent = ele.content;
          ele.isContentToggled = false;
          ele.content = this.formatContent(ele);
        });
      } else {
        this.trendingArr = [];
      }
    });
  }

  toggleContent(data): void {
    data.isContentToggled = !data.isContentToggled;
    data.content = data.isContentToggled
      ? data.nonEditedContent
      : this.formatContent(data);
  }

  formatContent(ele): any {
    if (ele.content.length > 100) {
      return `${ele.content.substr(0, 100)}...`;
    } else {
      return ele.content;
    }
  }

  likeUnlikeNews(data, typeId): void {
    const param = {
      txn_id: data.txn_id,
      type: typeId,
    };
    this.dashboardService.likeUnlikeNews(param).subscribe((res) => {
      if (data.can_like) {
        data.can_like = false;
        data.like_count = data.like_count + 1;
        this.newsStat.like_count = this.newsStat.like_count + 1;
      } else {
        data.can_like = true;
        if (data.like_count > 0) {
          data.like_count = data.like_count - 1;
          this.newsStat.like_count = this.newsStat.like_count - 1;
        }
      }
    });
  }

  doCommentNews(data, txnId, type): void {
    if (!data.usr_comment) {
      this.notifyService.showError('Please enter comment', 'Info!');
      return;
    }
    const param = {
      txn_id: txnId,
      comment: data.usr_comment,
      type: type,
    };
    this.dashboardService.commentActionNews(param).subscribe((res) => {
      if (type == 1) {
        data.comment_arr.push({
          can_like: true,
          txn_id: res.last_insert_id,
          comment: data.usr_comment,
          commentIndex: 2,
          date: moment().format('DD-MM-YYYY'),
          emp_img: '',
          name: localStorage.getItem('user_name'),
        });
        data.comment_count = data.comment_count + 1;
      } else {
        if (!data.reply_arr) {
          data.reply_arr = [];
        }
        data.reply_arr.push({
          can_like: true,
          txn_id: res.last_insert_id,
          comment: data.usr_comment,
          commentIndex: 2,
          date: moment().format('DD-MM-YYYY'),
          emp_img: '',
          name: localStorage.getItem('user_name'),
        });
      }
      data.comment_count = data.comment_count + 1;
      data.usr_comment = '';
      this.newsStat.comment_count = this.newsStat.comment_count + 1;
    });
  }

  viewAllCommentNews(data): void {
    data.commentIndex += 2;
  }

  hideCommentsNews(data): void {
    data.commentIndex = 2;
  }

  viewMoreGallery(): void {
    this.glryIndex += 3;
  }

  hideGallery(): void {
    this.glryIndex = 3;
  }

  getCategNews(data): void {
    if (data.value == 8) {
      this.router.navigateByUrl('/quick-links/policies');
    } else {
      this.headerName = data.label;
      this.commonData.cat_id = data.value;
      this.txnId = '';
      this.getGeneralNews(this.commonData);
      this.getGallery({ cat_id: data.value });
    }
  }

  pinNews(data): void {
    const param = {
      nws_txn_id: data.txn_id,
    };
    this.httpComs.pinNews(param).subscribe((res) => {
      this.notifyService.showSuccess(res.msg, 'Success!');
      data.can_pin = !data.can_pin;
    });
  }

  getGallery(data): void {
    this.httpComs.getGallery(data).subscribe((res) => {
      this.galleryData = res.data;
    });
  }

  openClubModal(id): void {
    $(id).modal({ backdrop: 'static', keyboard: false });
  }

  openGalleryModal(id, index, show): void {
    console.log(this.galleryData);
    console.log(index);
    this.crntEvent = this.galleryData[index].event_name;
    for (let i = 0; i < this.galleryData.length; i++) {
      if (this.galleryData[i].txn_id == this.galleryData[index].txn_id) {
        this.galleryData[i].is_active = true;
      } else {
        this.galleryData[i].is_active = false;
      }
    }
    this.httpComs
      .getGalleryPhotos(this.galleryData[index].txn_id)
      .subscribe((res) => {
        this.imagesArr = res.data;
        if (show) {
          $(id).modal({ backdrop: 'static', keyboard: false });
        }
      });
  }

  closeGalleryModal(): void {
    this.galleryData.forEach((ele) => {
      ele.is_active = false;
    });
    this.crntEvent = '';
  }

  submitNews(): void {
    this.submit = true;
    if (this.siteNewsForm.invalid) {
      return;
    }
    const newsFormData = new FormData();
    newsFormData.append('org_id', this.siteNewsForm.get('org_id').value);
    newsFormData.append('likes_allowed', '0');
    newsFormData.append('is_show_on_home', '0');
    newsFormData.append('comment_allwd', '0');
    newsFormData.append('is_show_on_hot', '0');
    newsFormData.append('source', 'Web');
    newsFormData.append(
      'short_desc',
      this.siteNewsForm.get('short_desc').value
    );
    newsFormData.append(
      'news_title',
      this.siteNewsForm.get('news_title').value
    );
    newsFormData.append('news_desc', this.siteNewsForm.get('news_desc').value);
    for (let i = 0; i < this.allFiles.length; i++) {
      newsFormData.append(`attachment[${i}]`, this.allFiles[i]);
    }
    this.httpComs.createNews(newsFormData, 0).subscribe((res) => {
      if (res.status) {
        this.notifyService.showSuccess(res.msg, 'Success!');
        this.closeSiteNewsModal();
      } else {
        this.notifyService.showError(res.msg, 'Error!');
      }
    });
  }

  droppedFiles(allFiles: File[]): void {
    const filesAmount = allFiles.length;
    for (let i = 0; i < filesAmount; i++) {
      const file = allFiles[i];
      this.allFiles.push(file);
    }
  }

  onChooseFile(event, id): void {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      if (id == 1) {
        this.allFiles.push(file);
      }
    }
  }

  siteNewsModal(id): void {
    $(id).modal({ backdrop: 'static', keyboard: false });
  }

  closeSiteNewsModal(): void {
    $('#site_news_modal').modal('hide');
    this.allFiles = [];
    this.siteNewsForm.reset({
      org_id: this.siteNewsForm.get('org_id').value,
    });
    this.submit = false;
  }

  deleteIndex(index): void {
    this.allFiles.splice(index, 1);
  }

  readMore(data): void {
    this.newsData = [];
    this.newsData.push(data);
  }

  ngOnDestroy(): void {
    this.httpGen.showLang.next(false);
  }

  moreNews(): void {
    this.commonData.limit += 5;
    this.getGeneralNews(this.commonData);
  }

  goToMyFeed(): void {
    this.commonData.limit = 5;
    this.commonData.cat_id = '';
    this.commonData.source = 'Web';
    this.headerName = 'My Feed';
    this.getGeneralNews(this.commonData);
  }
}
